import { accountService } from "../services/accountService";

export function authHeader() {
    let token = localStorage.getItem("token");
    if (token) {
        return {"Authorization": "Bearer " + token};
    } else {
        return {};
    }
}

export async function authHeaderAsync() {
    let tokenStr = localStorage.getItem("token");
    if (!tokenStr)
        return {};
    let token = parseJwt(tokenStr);
    let valid = token.exp > Math.floor(Date.now() / 1000);
    if(!valid) {
        await accountService.refreshToken();
        return await authHeaderAsync();
    }
    return {"Authorization": "Bearer " + tokenStr};
}

function parseJwt(token) {
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));

    return JSON.parse(jsonPayload);
}